import script from "./AreaSelectorMenuBranch.vue?vue&type=script&setup=true&lang=ts"
export * from "./AreaSelectorMenuBranch.vue?vue&type=script&setup=true&lang=ts"

import "./AreaSelectorMenuBranch.vue?vue&type=style&index=0&id=eb4d51fc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb4d51fc"]])

export default __exports__